import { render } from "./ImageZoomOverlay.vue?vue&type=template&id=6d365a32&scoped=true"
import script from "./ImageZoomOverlay.vue?vue&type=script&lang=js"
export * from "./ImageZoomOverlay.vue?vue&type=script&lang=js"

import "./ImageZoomOverlay.vue?vue&type=style&index=0&id=6d365a32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d365a32"]])

export default __exports__